import * as Yup from 'yup';

export const getValidationSchemaNotification = (intl) =>
    Yup.object().shape({
        header: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        body: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
    });
